var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable import/no-extraneous-dependencies */
import { inject } from 'mobx-react';
import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { EGDSLayoutFlex } from '@egds/react-core/layout-flex';
import { EGDSText } from '@egds/react-core/text';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { SharedUIFooter } from './shared-ui-footer';
import { Sections } from '../sections/sections';
import { sectionTypes, isValidSection, setSectionData, setMinimalSectionData } from './footer-sections';
import { CustomerNotifications } from '../customer-notifications';
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Footer.prototype.render = function () {
        var _a;
        var _b = this.props, globalComponentsContext = _b.globalComponentsContext, children = _b.children, minimal = _b.minimal, marqueeClass = _b.marqueeClass, skipSsr = _b.skipSsr, page = _b.page;
        var footer = (globalComponentsContext && globalComponentsContext.footer) || null;
        if (!footer) {
            return null;
        }
        var sections = (footer && footer.sections) || [];
        var hasValidSections = sections.find(isValidSection);
        var useSharedUIFooter = ((_a = globalComponentsContext === null || globalComponentsContext === void 0 ? void 0 : globalComponentsContext.footer) === null || _a === void 0 ? void 0 : _a.useSharedUIFooter) || false;
        if (minimal) {
            var minimalSection = sections.find(function (section) { return section.templateRegionId === 'minimalLinks'; });
            sections = sections.filter(function (section) { return setMinimalSectionData(section); });
            sections.unshift(minimalSection);
        }
        else {
            sections = sections.filter(function (section) { return setSectionData(section); });
        }
        var classNames = [
            'mad-marquee-container',
            marqueeClass
        ].filter(function (style) { return typeof style === 'string'; });
        return (React.createElement(React.Fragment, null,
            React.createElement(Experiment, { name: "PWA_MAD_Marquee" },
                React.createElement(ExperimentControl, null),
                React.createElement(ExperimentVariant, { bucket: 1 },
                    React.createElement(EGDSSpacing, { padding: { inline: 'three' } },
                        React.createElement("div", { className: classNames.join(' ') },
                            React.createElement("div", { className: marqueeClass },
                                React.createElement(CustomerNotifications, { location: "FOOTER" })))))),
            useSharedUIFooter ? (React.createElement(SharedUIFooter, { minimal: minimal, skipSsr: skipSsr, page: page })) : (React.createElement(Experiment, { name: "Shared_UI_Footer" },
                React.createElement(ExperimentControl, null,
                    React.createElement(EGDSText, { align: "center", size: 200 },
                        React.createElement("footer", { className: "footer" },
                            React.createElement(EGDSLayoutFlex, { justifyContent: "center" },
                                React.createElement("div", { className: "footer-container" },
                                    children,
                                    sections && hasValidSections && (React.createElement("div", { className: "footer-sections" },
                                        React.createElement(Sections, { sectionList: sections, types: sectionTypes })))))))),
                React.createElement(ExperimentVariant, { bucket: 1 },
                    React.createElement(SharedUIFooter, { minimal: minimal, skipSsr: skipSsr, page: page }))))));
    };
    Footer = __decorate([
        inject('globalComponentsContext')
    ], Footer);
    return Footer;
}(React.Component));
export { Footer };
//# sourceMappingURL=footer.js.map